import styled from "@emotion/styled";
import { LdTypo } from "@liquid/react";
import { Link } from "react-router-dom";

import { StyledSidePaddings } from "@src/components";
import { zIndex } from "@src/styles";
import { pxToRem } from "@src/utils";

const StyledFooter = styled(StyledSidePaddings)`
  position: relative;
  z-index: ${zIndex.footer};
  margin: ${pxToRem(32)} 0 ${pxToRem(32)} ${pxToRem(32)};
`.withComponent("footer");

const StyledLegalLinks = styled.div`
  display: flex;
  gap: ${pxToRem(20)};
`;

const StyledLink = styled(Link)`
  color: var(--ld-col-wht);
  font: var(--ld-typo-body-s);
`;

const StyledCookieButton = styled.div`
  #ot-sdk-btn.ot-sdk-show-settings {
    padding: 0;
    border: none;
    background-color: transparent;
    color: var(--ld-col-wht);
    font: var(--ld-typo-body-s);
    text-decoration: underline;

    &:hover {
      color: var(--ld-col-wht);
      cursor: pointer;
      background-color: transparent;
    }
  }
`;

const StyledPrivacyPolicy = styled.a`
  color: var(--ld-col-wht);
  font: var(--ld-typo-body-s);
`;

const StyledLegalDisclaim = styled(LdTypo)`
  color: var(--ld-col-neutral-800);
  align-items: center;
  display: flex;
`;

const StyledImg = styled.img`
  height: 40px;
`;
export {
  StyledFooter,
  StyledLegalLinks,
  StyledLink,
  StyledPrivacyPolicy,
  StyledLegalDisclaim,
  StyledCookieButton,
  StyledImg,
};
